import DarkTheme from './dark-theme';

const LightContrastBiggerTheme = {
	...DarkTheme,

	code: 'dark-contrast-bigger',

	fontColor: 'rgba(255,255,255,0.9)',
	fontSize: 14
};

export default LightContrastBiggerTheme;